import React, { useState } from 'react';
import cx from 'classnames';
import moment from 'moment-timezone';
import { Collapse } from 'react-bootstrap';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import StatusBadge from '../../status_badge';
import { WorkflowTask } from '../types';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  isSubworkflow?: boolean;
  tasks: WorkflowTask[];
}

const CollapsibleTaskLogs: React.FC<Props> = (props) => {
  const [showLogs, setLogs] = useState(false);

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  return (
    <div>
      <span onClick={() => setLogs(!showLogs)} style={{ cursor: 'pointer' }}>
        <FontAwesomeIcon icon={showLogs ? 'caret-down' : 'caret-right'}/>{' '}
        <span style={{ fontSize: props.isSubworkflow ? 12 : 14 }}>Show Logs</span>
      </span>

      <Collapse in={showLogs}>
        <div className="u-margin-T-xs">
          {
            props.tasks.map((task, idx) => (
              <React.Fragment key={task.id}>
                <div
                  className={cx({ 'u-padding-A-s': !props.isSubworkflow, 'u-padding-V-s': props.isSubworkflow })}
                  style={{ backgroundColor: props.isSubworkflow ? '#f5f5f5' : colors.grayLighter }}
                >
                  <div className="d-flex flex-column gap-xs">
                    <div className="align-items-center d-flex gap-xs">
                      <div><StatusBadge status={task.status} /></div>
                      <div><strong><small>{task.identifier}</small></strong></div>
                    </div>

                    <div className="d-flex flex-column gap-xs">
                      {
                        task.events.map((event) => {
                          if (event.content.description?.match(/Transitioned from \w+ to \w+/)) {
                            const events = event.content.description?.match(/Transitioned from (\w+) to (\w+)/)
                            return (
                              <div key={event.id} className="align-items-center d-flex gap-xs">
                                <div><StatusBadge status={events[1]} /></div>
                                <div>
                                  <FontAwesomeIcon className="text-gray-light" icon="arrow-right" style={{ fontSize: 12 }} />
                                </div>
                                <div><StatusBadge status={events[2]} /></div>
                                <div style={{ fontSize: 12 }}>
                                  {moment(event.createdAt * 1000).tz(timeZone).format('LLL')}
                                </div>
                              </div>
                            );
                          } else if (event.event === 'subworkflow') {
                            const subworkflow = task.subworkflows.find((subworkflow) => (
                              subworkflow.id == event.content.data.id
                            ));

                            return (
                              <div key={event.id} className="d-flex flex-column gap-xs">
                                <div className="align-items-center d-flex gap-xs">
                                  <div><StatusBadge status={event.event} /></div>
                                  <div className="text-underdash" style={{ fontSize: 12 }}>
                                    <strong>{subworkflow.name}</strong>
                                  </div>
                                  <div style={{ fontSize: 12 }}>
                                    {moment(event.createdAt * 1000).tz(timeZone).format('LLL')}
                                  </div>
                                </div>

                                <div
                                  className="u-margin-L-s u-padding-H-xs u-padding-V-xxs"
                                  style={{ backgroundColor: '#f5f5f5', borderLeft: '1px solid #ccc' }}
                                >
                                  <CollapsibleTaskLogs isSubworkflow tasks={subworkflow.tasks} />
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div key={event.id}>
                                <div className="d-flex flex-column gap-xs">
                                  <div className="align-items-center d-flex gap-xs">
                                    <div><StatusBadge status={event.event} /></div>
                                    <div style={{ fontSize: 12 }}>
                                      {moment(event.createdAt * 1000).tz(timeZone).format('LLL')}
                                    </div>
                                  </div>

                                  <div className="flex-1">
                                    <pre style={{ fontSize: 12 }}>
                                      {JSON.stringify(event.content, null, 2)}
                                    </pre>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })
                      }
                    </div>
                  </div>
                </div>

                {idx != props.tasks.length - 1 && <hr className="u-margin-A-n u-margin-V-xxs" />}
              </React.Fragment>
            ))
          }
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsibleTaskLogs;
